import { cleanNotifications } from '@mantine/notifications';
import { UNEXPECTED_ERROR_MESSAGE } from '@zorro/common-utils';
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from '@zorro/design-system/v2/Toast';

export type NotificationConfig = {
  message?: string;
  id?: string;
  title?: string;
  autoClose?: boolean;
};

export const showErrorNotification = ({
  message = UNEXPECTED_ERROR_MESSAGE,
  title = 'Oh no!',
  id,
}: Omit<NotificationConfig, 'autoClose'> = {}) => {
  const tornadoBaseUrl = process.env.NEXT_PUBLIC_TORNADO_BASE_URL;

  let autoClose = false;
  if (typeof window !== 'undefined' && tornadoBaseUrl) {
    autoClose = window.location.href.includes(tornadoBaseUrl);
  }

  showErrorToast({ id, title, message, autoClose });
};

export const showWarningNotification = ({
  message,
  title,
  id,
  autoClose = true,
}: NotificationConfig = {}) => {
  showWarningToast({ id, title, message, autoClose });
};

export const showSuccessNotification = ({
  message,
  title = 'Success!',
  id,
  autoClose = true,
}: NotificationConfig = {}) => {
  showSuccessToast({ id, title, message, autoClose });
};

export const clearAllNotifications = () => {
  cleanNotifications();
};
